import { render, staticRenderFns } from "./CompanyPriceRuleModal.vue?vue&type=template&id=2200e666&"
import script from "./CompanyPriceRuleModal.vue?vue&type=script&lang=js&"
export * from "./CompanyPriceRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports